<template>
	<div>
		<svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<g id="Megaphone" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g>
					<rect id="bg-tabbar-icon" x="0" y="0" width="44" height="44"></rect>
					<path d="M22,11.44 L22,27.28 L18.48,27.28 L21.12,35.2 C22.2243138,36.3043138 22.2892734,37.4086275 21.3148788,38.5129411 L21.12,38.72 L18.08356,41.49365 C17.6231,41.97435 16.98048,42.24253 16.30497,42.24253 C16.13799,42.24253 15.96848,42.22482 15.79897,42.1894 C15.029344,42.034564 14.3888239,41.5415935 14.0415586,40.8525051 L13.93689,40.61574 L8.8,27.28 L5.28,27.28 L5.28101033,27.192189 C3.27213549,26.7849016 1.76,25.00904 1.76,22.88 L1.76,22.88 L1.76,15.84 L1.76935912,15.5506988 C1.91833194,13.2555033 3.82714922,11.44 6.16,11.44 C6.36479691,11.44 6.56632588,11.4539917 6.76368317,11.4810713 L6.88532509,11.4531487 L6.88532509,11.4531487 L7.04,11.44 L22,11.44 Z M40.975,1.76 C42.1556666,1.76 42.2343779,2.65038009 42.2396251,2.96656788 L42.24,3.025 L42.24,35.915 C42.24,36.96 41.11921,37.18 40.975,37.18 C40.79031,37.18 40.61827,37.13699 40.45888,37.06868 C40.42093,37.05097 40.12745,36.8511 40.0389,36.75243 C40.02625,36.73725 40.00854,36.73219 39.99842,36.71954 C36.2058527,32.1144535 31.0764233,28.9783388 25.3322103,27.7003008 L24.64,27.55588 L24.64,11.38665 C30.66393,10.21273 36.05415,7.00975 39.99842,2.22046 C40.00854,2.21034 40.02372,2.20781 40.03384,2.19769 C40.18311,2.03071 40.48,1.76 40.975,1.76 Z" id="Combined-Shape" :fill="color" fill-rule="nonzero"></path>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBank',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
	},
};
</script>

<style scoped>

</style>